import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  get_NullableIntAdapter1poaa869odci7 as get_NullableIntAdapter,
  get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter,
  nullable1in0t8o94jx9t as nullable,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_getInstance313brsqqgys0x as Companion_getInstance } from '../GraphQLFloat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from '../SavePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyInput_InputAdapterClass;
function SavePartyInput_InputAdapter() {
  if (SavePartyInput_InputAdapterClass === VOID) {
    class $ {
      s3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      j6q(writer, customScalarAdapters, value) {
        writer.v47('partyId');
        get_partyIdAdapter().t3z(writer, customScalarAdapters, value.n6o_1);
        var tmp = value.o6o_1;
        if (tmp instanceof Present()) {
          writer.v47('name');
          present(get_NullableStringAdapter()).c41(writer, customScalarAdapters, value.o6o_1);
        }
        var tmp_0 = value.p6o_1;
        if (tmp_0 instanceof Present()) {
          writer.v47('email');
          present(get_NullableStringAdapter()).c41(writer, customScalarAdapters, value.p6o_1);
        }
        var tmp_1 = value.q6o_1;
        if (tmp_1 instanceof Present()) {
          writer.v47('pairingRule');
          present(get_NullableIntAdapter()).c41(writer, customScalarAdapters, value.q6o_1);
        }
        var tmp_2 = value.r6o_1;
        if (tmp_2 instanceof Present()) {
          writer.v47('badgesEnabled');
          present(get_NullableBooleanAdapter()).c41(writer, customScalarAdapters, value.r6o_1);
        }
        var tmp_3 = value.s6o_1;
        if (tmp_3 instanceof Present()) {
          writer.v47('defaultBadgeName');
          present(get_NullableStringAdapter()).c41(writer, customScalarAdapters, value.s6o_1);
        }
        var tmp_4 = value.t6o_1;
        if (tmp_4 instanceof Present()) {
          writer.v47('alternateBadgeName');
          present(get_NullableStringAdapter()).c41(writer, customScalarAdapters, value.t6o_1);
        }
        var tmp_5 = value.u6o_1;
        if (tmp_5 instanceof Present()) {
          writer.v47('callSignsEnabled');
          present(get_NullableBooleanAdapter()).c41(writer, customScalarAdapters, value.u6o_1);
        }
        var tmp_6 = value.v6o_1;
        if (tmp_6 instanceof Present()) {
          writer.v47('animationsEnabled');
          present(get_NullableBooleanAdapter()).c41(writer, customScalarAdapters, value.v6o_1);
        }
        var tmp_7 = value.w6o_1;
        if (tmp_7 instanceof Present()) {
          writer.v47('animationSpeed');
          present(nullable(customScalarAdapters.e46(Companion_getInstance().d6l_1))).c41(writer, customScalarAdapters, value.w6o_1);
        }
      }
      t3z(writer, customScalarAdapters, value) {
        return this.j6q(writer, customScalarAdapters, value instanceof SavePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePartyInput_InputAdapterClass = $;
  }
  return SavePartyInput_InputAdapterClass;
}
var SavePartyInput_InputAdapter_instance;
function SavePartyInput_InputAdapter_getInstance() {
  return SavePartyInput_InputAdapter_instance;
}
//region block: init
SavePartyInput_InputAdapter_instance = new (SavePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePartyInput_InputAdapter_instance as SavePartyInput_InputAdapter_instanceergmyw6zfzfp,
};
//endregion

//# sourceMappingURL=SavePartyInput_InputAdapter.mjs.map
